import { useEffect } from "react";

import { HUBSPOT_PORTAL_ID } from "core/config/config";
import { useCookieContext } from "core/contexts/CookieContext";
import { removeUnconsentedCookies } from "core/includes/cookies";
import { useAppState } from "core/contexts/AppContext";
import { FLAG_COOKIE_SETTINGS } from "core/includes/featureFlags";
import { hasFeatureFlag } from "core/includes/site";
import window, { hasWindow } from 'core/includes/window';

const HUBSPOT_SCRIPT_ID = "hubspot-script";

const useHubspotIntegration = (): void => {
    const { consentedCategories } = useCookieContext();
    const [appState] = useAppState();
    const hasCookieSettingsFlag = hasFeatureFlag(appState.featureFlags, FLAG_COOKIE_SETTINGS);

    useEffect(function toggleHubspotScripts() {
        if (!hasWindow) return;

        const isHubspotScriptsAllowed =
            (!hasCookieSettingsFlag && !appState.isLoadingFeatureFlags) ||
            consentedCategories.some(category => category.isAnalytics)
        ;

        if (isHubspotScriptsAllowed && !document.getElementById(HUBSPOT_SCRIPT_ID)) {
            const script = document.createElement("script");
            script.src = `https://js.hs-scripts.com/${HUBSPOT_PORTAL_ID}.js`;
            script.id = HUBSPOT_SCRIPT_ID;
            script.async = true;
            document.body.appendChild(script);
            script.onload = () => {
                window._hsq = window._hsq || []
            }
        } else if (!isHubspotScriptsAllowed) {
            document.getElementById(HUBSPOT_SCRIPT_ID)?.remove();
            removeUnconsentedCookies();
        }
    }, [hasCookieSettingsFlag, appState.isLoadingFeatureFlags, consentedCategories]);
};

export default useHubspotIntegration;
